import React from "react";
import { MdClose, MdWarning } from "react-icons/md";
import { Container, ModalStyle, ModalHeader, Content } from "./styles";

function CondoUnavailable({ show = false, toggleModal = () => {} }) {
  return (
    <ModalStyle
      show={show}
      onHide={() => toggleModal(false)}
      aria-labelledby="Sem condomínio nesse cep"
      centered
      animation={false}
    >
      <ModalHeader>
        <span>Condomínio indisponível</span>
        <MdClose size={24} onClick={() => toggleModal(false)} />
      </ModalHeader>
      <Container>
        <Content>
          <MdWarning size={24} color="#FF8000" />
          <p>
            O novo portal ainda não está disponível para seu condomínio
          </p>
        </Content>

        <span>
          Acesse o <a href="https://ug.force.com/mi/milogin" target="_blank" name="Portal Autoatendimento" aria-label="Portal Autoatendimento" rel="external">site</a> para se cadastrar
        </span>
      </Container>
    </ModalStyle>
  );
}

export default CondoUnavailable;